import { useTranslation } from "react-i18next"
import { SwitchToChromeDialog } from "./SwitchToChromeDialog"

type MasksUnavailableDialogProps = {
	onDismiss?: () => void
}

export const MasksUnavailableDialog = ({ onDismiss }: MasksUnavailableDialogProps) => {
	const { t } = useTranslation("components")
	return (
		<SwitchToChromeDialog
			onDismiss={onDismiss}
			bodyText={t("masksUnavailableDialog.bodyText")}
			trackingViewName="masks_unavailable_dialog"
		/>
	)
}
